module.exports = __webpack_public_path__ + "img/special-bg.5c2b5f71.png";